import PipelinesPage from 'components/Pipelines'

export default PipelinesPage
